const Ui = require('./Ui');
const $ = require('jquery');
const Segment = require('../data/Segment');
const constants = require('../data/constants');

class TurnRestrictions {
  /**
   * @param {Map} map
   * @param {Api} api
   * @param {string} sessionId
   * @param {Localization} localization
   */
  constructor(map, api, sessionId, localization) {
    this.map = map.map;
    this.api = api;
    this.sessionId = sessionId;
    this.openFile = null;
    this.maneuvers = null;
    this.localization = localization;
    this.maneuversListListener = null;
    this.renderer = new IWMapRenderer(this.map);
    this.drawnManeuvers = [];
    this.colorManeuverActivated = '#fdad14';
    this.colorManeuverDeactivated = '#01fd64';
    this.colorManeuverEdited = '#3fd4e3';
    this.mousePositionOnMap = null;
    this.uiContextMenu = $('#turn-restriction-context-menu');
    this.uiEditTurnRestrictionModal = $('.edit-turnrestriction');
    this.restrictionToEdit = null;
  }

  enable(openFile) {
    this.openFile = openFile;

    this.maneuvers = new IWManeuvers(this.map);

    this.addListeners();

    setTimeout(() => {
      this.maneuvers.getList(true, true, true, {});
    }, 500);
  }

  disable() {
    this.openFile = null;
    this.clearPreviouslyDrawnManeuvers();
    IWEventManager.removeListener(this.maneuversListListener);
  }

  draw() {

    if (this.map.getZoom() < 16 || !this.results) {
      return;
    }

    this.clearPreviouslyDrawnManeuvers();

    this.results.forEach((maneuver) => {
      const { coordinates, OLR } = maneuver;

      const segment = this.openFile.file.getTurnRestrictionByOlr(OLR);

      let strokeColor = this.colorManeuverActivated;

      if(segment && segment.attributes.detourEditor_editedOriginal) {
        strokeColor = this.colorManeuverEdited;
      } else if (segment && segment.flag !== constants.SEGMENT_DELETED) {
        strokeColor = this.colorManeuverDeactivated;
      }

      const polyline = this.renderer.drawPolyline(
        coordinates,
        {
          stroke: strokeColor,
          strokeWidth: this.getStrokeWidth(),
          strokeOpacity: 1,
        },
      );

      IWEventManager.addCustomListener(polyline, 'onmouseover', () => {
        polyline.shapes.forEach((shape) => {
          shape.style.stroke = 'blue'; // eslint-disable-line no-param-reassign
        });
      });

      IWEventManager.addCustomListener(polyline, 'onmouseout', () => {
        polyline.shapes.forEach((shape) => {
          shape.style.stroke = strokeColor; // eslint-disable-line no-param-reassign
        });
      });

      if(this.openFile.hasTurnRestrictionPermission) {
        IWEventManager.addCustomListener(polyline, 'oncontextmenu', () => {
          this.showContextMenu({
            left: this.mousePositionOnMap.left, top: this.mousePositionOnMap.top,
          }, OLR, segment, coordinates);
        });

        IWEventManager.addCustomListener(polyline, 'ondblclick', (event) => {
          event.preventDefault();
          this.openFile.hasReachedDetourLimit()
            .then(result => {
              if(result) {
                this.openFile.uiLimitReachModal.modal('show');
              } else {
                this.showEditTurnRestrictionModal(OLR, segment, coordinates);
              }
            });
        });

      }

      this.drawnManeuvers.push(polyline);
    });

    this.renderer.render();
  }

  showContextMenu(position, olr, segment, coordinates) {
    const buttonDeactivate = this.uiContextMenu.find('#turn-restriction-disable');
    const buttonEnable = this.uiContextMenu.find('#turn-restriction-enable');
    const buttonEdit = this.uiContextMenu.find('#turn-restriction-edit');
    const buttonEditRemove = this.uiContextMenu.find('#turn-restriction-edit-remove');

    if (segment && segment.flag !== constants.SEGMENT_DELETED) {
      buttonDeactivate.hide();
      buttonEditRemove.hide();
      buttonEdit.hide();
      buttonEnable.show();

      if(segment.attributes.detourEditor_editedOriginal) {
        buttonEnable.hide();
        buttonEditRemove.show();
        buttonEdit.show();
      }

    } else {
      buttonDeactivate.show();
      buttonEdit.show();
      buttonEnable.hide();
      buttonEditRemove.hide();
    }

    buttonDeactivate.off('click.restriction');
    buttonEnable.off('click.restriction');
    buttonEdit.off('click.restriction');
    buttonEditRemove.off('click.restriction');

    buttonDeactivate.on('click.restriction', (e) => {
      this.openFile.hasReachedDetourLimit()
        .then(result => {
          if(result) {
            this.openFile.uiLimitReachModal.modal('show');
          } else {
            this.deactivateTurnRestriction(olr, segment, coordinates);
          }
        });
      e.preventDefault();
    });

    buttonEnable.on('click.restriction', (e) => {
      this.activateTurnRestriction(segment);
      e.preventDefault();
    });

    buttonEdit.on('click.restriction', (e) => {
      e.preventDefault();
      this.openFile.hasReachedDetourLimit()
        .then(result => {
          if(result && !segment) {
            this.openFile.uiLimitReachModal.modal('show');
          } else {
            this.showEditTurnRestrictionModal(olr, segment, coordinates);
          }
        });
    });

    buttonEditRemove.on('click.restriction', (e) => {
      this.activateTurnRestriction(segment);
      e.preventDefault();
    });

    this.uiContextMenu.css(position).show();
  }

  showEditTurnRestrictionModal(olr, segment, coordinates) {
    this.restrictionToEdit = segment;

    this.uiEditTurnRestrictionModal.find('form')[0].reset();
    this.uiEditTurnRestrictionModal.find('#editTurnrestrictionFormDelete').hide();

    const emergencyRoutingSettings = this.uiEditTurnRestrictionModal.find('#emergency-routing-settings-cb-tr');
    const emergencyRadiusSettings = this.uiEditTurnRestrictionModal.find('#emergency-routing-radius-cb-tr');
    const normalRoutingSettings = this.uiEditTurnRestrictionModal.find('#normal-routing-settings-cb-tr');

    if(!this.restrictionToEdit) {

      this.restrictionToEdit = new Segment(
        0,
        null,
        olr,
        {
          modify_MANEUVERS: 'add',
          description: this.localization.translate('general.turn-restriction'),
          detourEditor_turnArrowCoords: coordinates.map((coordinateTemp) => {
            const coordinate = coordinateTemp.toWGS84();
            return `${coordinate.getX()},${coordinate.getY()}`;
          })
            .join(';'),
          detourEditor_hasArrowSet: true,
          SegmentType: constants.SEGMENT_TYPE_ADDED_MANEUVER,
          detourEditor_editedOriginal: true,
          MapVersion: this.openFile.currentBuildVersion
        },
        constants.SEGMENT_NEW
      );

      normalRoutingSettings.prop('checked', true);
      emergencyRoutingSettings.prop('checked', true);
      emergencyRadiusSettings.prop('checked', false);

      this.openFile.updateNormalRoutingLabelTr(true);
      this.openFile.updateEmergencyRoutingLabelTr(true);
      this.openFile.updateEmergencyRadiusLabelTr(false);

      this.uiEditTurnRestrictionModal.find('#editTurnrestrictionFormHash').val(null);

    } else {
      this.uiEditTurnRestrictionModal.find('#editTurnrestrictiontFormName').val(segment.getAttributeByName('description'));
      this.uiEditTurnRestrictionModal.find('#editTurnrestrictionFormHash').val(segment.hash);

      const validity = segment.getAttributeByName('validity');

      let validityNormal = (validity >> 4) % 4;
      let validityRadius = (validity >> 2) % 4;
      let validityRouting = (validity >> 0) % 4;

      emergencyRoutingSettings.prop('checked', (validityRouting === 0 || validityRouting === 1));
      emergencyRadiusSettings.prop('checked', (validityRadius === 0 || validityRadius === 1));
      normalRoutingSettings.prop('checked', (validityNormal === 0 || validityNormal === 1));

      this.openFile.updateEmergencyRoutingLabelTr(emergencyRoutingSettings.is(':checked'));
      this.openFile.updateEmergencyRadiusLabelTr(emergencyRadiusSettings.is(':checked'));
      this.openFile.updateNormalRoutingLabelTr(normalRoutingSettings.is(':checked'));

      this.uiEditTurnRestrictionModal.find('#editTurnrestrictionFormDelete').show().off('click.deletesegment').on('click.deletesegment', () => {
        this.activateTurnRestriction(segment);
        this.uiEditTurnRestrictionModal.modal('hide');
      });
    }

    this.openFile.setEmergencySettingsTurnRestrictionListener();
    this.openFile.updateTurnRestrictionMap(this.restrictionToEdit);
    this.uiEditTurnRestrictionModal.modal('show');
  }

  finishEditTurnRestriction() {
    const hash = this.uiEditTurnRestrictionModal.find('#editTurnrestrictionFormHash').val();
    let oldSegment = null;
    let attributes = {};
    if (hash) {
      oldSegment = this.openFile._file.getSegmentByHash(hash);
      attributes = $.extend(true,{},oldSegment.attributes);
      delete attributes.speed;
    } else {
      oldSegment = this.restrictionToEdit;
    }

    attributes.SegmentType = constants.SEGMENT_TYPE_ADDED_MANEUVER;
    attributes.modify_MANEUVERS = 'add';

    attributes.description = TurnRestrictions.sanitize(this.uiEditTurnRestrictionModal.find('#editTurnrestrictiontFormName').val());
    attributes.detourEditor_editedOriginal = true;

    let validityRouting = 0;
    let validityRadius = 0;
    let validityNormal = 0;

    const activeInEmerRouting = this.uiEditTurnRestrictionModal.find('#emergency-routing-settings-cb-tr').is(':checked');
    const activeInEmerRadius = this.uiEditTurnRestrictionModal.find('#emergency-routing-radius-cb-tr').is(':checked');
    const activeInRouting = this.uiEditTurnRestrictionModal.find('#normal-routing-settings-cb-tr').is(':checked');

    if(activeInRouting && activeInEmerRouting && !activeInEmerRadius) {
      Ui.showModalError(this.localization.translate('errors.turn-restriction-no-changes'));
      return;
    }

    validityRouting = activeInEmerRouting ? 1 : 2;
    validityRadius = activeInEmerRadius ? 1 : 2;
    validityNormal = activeInRouting ? 1 : 2;

    attributes.validity =  validityRouting + (validityRadius*4) + (validityNormal*16);

    if(oldSegment.hasOwnProperty.call(oldSegment._attributes, 'detourEditor_turnArrowCoords')) {
      attributes.detourEditor_turnArrowCoords = oldSegment.getAttributeByName('detourEditor_turnArrowCoords');
      attributes.detourEditor_hasArrowSet = true;
    }

    const segment = new Segment(
      oldSegment.id,
      oldSegment.coordinates,
      oldSegment.olr,
      attributes,
      constants.SEGMENT_NEW,
    );

    const currentDate = new Date().toISOString();

    if (segment.id && segment.id !== 0 && segment.id !== "0") {
      segment.flag = constants.SEGMENT_EDITED;
    }

    if(hash) {
      if(oldSegment.attributes.detourEditor_created) {
        segment.attributes.detourEditor_created = oldSegment.attributes.detourEditor_created;
      }
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.openFile.user._username;

      this.openFile._file.replaceSegment(oldSegment, segment);
      Ui.updateSegmentListRow(segment, this.openFile._localization);
    } else {
      segment.attributes.MapVersion = this.openFile.currentBuildVersion;
      segment.attributes.detourEditor_created = currentDate;
      segment.attributes.detourEditor_modified = currentDate;
      segment.attributes.detourEditor_modifiedBy = this.openFile.user._username;
      this.openFile._file.addSegment(segment);
      Ui.addSegmentListRow(segment, this.openFile._localization);
    }

    this.openFile.updateSaveBadge();
    this.uiEditTurnRestrictionModal.modal('hide');

    this.draw();
  }

  activateTurnRestriction(segment) {
    if (segment.flag === constants.SEGMENT_PUBLISHED) {
      this.openFile.file.markSegmentAsDeleted(segment.hash);
      Ui.updateSegmentListRow(segment, this.openFile._localization);
    } else {
      this.openFile.file.removeSegmentByHash(segment.hash);
      Ui.removeSegmentListRow(segment);
    }


    this.openFile.updateSaveBadge();
    this.draw();
  }

  deactivateTurnRestriction(olr, segment, coordinates) {
    let newSegment = segment;

    if (!newSegment) {
      newSegment = new Segment(
        0,
        null,
        olr,
        {
          modify_MANEUVERS: 'delete',
          description: this.localization.translate('general.turn-restriction'),
          editor_coordinates: coordinates.map((coordinateTemp) => {
            const coordinate = coordinateTemp.toWGS84();
            return `${coordinate.getX()},${coordinate.getY()}`;
          }).join(';'),
          SegmentType: constants.SEGMENT_TYPE_DELETED_MANEUVER,
          MapVersion: this.openFile.currentBuildVersion
        },
        constants.SEGMENT_NEW,
      );
      Ui.addSegmentListRow(newSegment, this.openFile._localization);
      this.openFile.file.addSegment(newSegment);
    } else {
      // eslint-disable-next-line max-len
      Ui.updateSegmentListRow(segment, this.openFile._localization);
      newSegment.flag = segment.flag === constants.SEGMENT_DELETED ? constants.SEGMENT_PUBLISHED : constants.SEGMENT_NEW;
    }


    this.openFile.updateSaveBadge();
    this.draw();
  }

  clearPreviouslyDrawnManeuvers() {
    this.drawnManeuvers.forEach((maneuver) => {
      this.renderer.removeElement(maneuver);
    });

    this.drawnManeuvers = [];
  }

  setMapProject(project) {
    this.clearPreviouslyDrawnManeuvers();
    this.maneuvers._setProject(project);
    this.draw();
  }

  getStrokeWidth() {
    const currentZoom = this.map.getZoom();

    if (currentZoom > 16) return 5;

    if (currentZoom > 15) return 2;

    if (currentZoom > 11) return 1;

    if (currentZoom > 0) return 0;

    return 0;
  }

  addListeners() {
    this.maneuversListListener = IWEventManager.addCustomListener(this.maneuvers, 'ongetlist', (results) => {
      this.results = results.results;

      this.draw();
    });

    $('.map').on('mousemove', (event) => {
      this.mousePositionOnMap = {
        left: event.originalEvent.pageX,
        top: event.originalEvent.pageY,
      };
    });

    this.uiEditTurnRestrictionModal.find('#editTurnrestrictionFormSubmit').off().on('click', e => {
      e.preventDefault();
      this.finishEditTurnRestriction();
    });

    this.uiEditTurnRestrictionModal.on('hide.bs.modal',() => {
      this.restrictionToEdit = null;
    })
  }

  static sanitize(string) {
    const map = {
      '<': ' ',
      '>': ' ',
      "/": ' ',
    };
    const reg = /[<>/]/ig;
    return string.replace(reg, (match)=>(map[match]));
  }
}

module.exports = TurnRestrictions;
